import { forwardRef, useImperativeHandle, useState } from "react";
import { _showToast } from "../../../toastHelper";
import ImageCropping from "./ImageCropping";


const ImageBrowse = forwardRef(function ImageBrowse({ elementId, imageType, imageKey, setImageKey, imageDelete }, ref) {
    const [showCropperModal, setshowCropperModal] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [thumbnail, setThumbnail] = useState(null);

    const browseThumbnail = () => {
        document.getElementById(elementId).click();
    }

    const handleThumbailChange = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            if (validateFile(file)) {
                setImageFile(file);
                setshowCropperModal(true);
            }
            else {
                document.getElementById(elementId).value = null;
            }
        }
    }

    const validateFile = (file) => {
        let imageType = /image.*/;
        if (file && file.size > 1048576) {
            _showToast("Maximum file size allowed is 1MB, please try with different file.", "error");
            return false;
        }

        if (!file.type.match(imageType)) {
            _showToastt("File types with extension " + file.name.split('.').pop() + " are not supported.", "error");
            return false;
        }
        return true;
    }

    const handleCropSave = (croppedImage, type) => {
        const file = croppedImage;
        const imageUrl = URL.createObjectURL(file);
        let container = new DataTransfer();
        container.items.add(file);
        setThumbnail(imageUrl);
        document.getElementById(elementId).files = container.files;
        setshowCropperModal(false);
        setImageFile(null);
    };

    const handleModalClose = () => {
        setshowCropperModal(false);
        document.getElementById(elementId).value = null;
    };

    const handleRemoveFile = (e, imageKey) => {
        e.stopPropagation();
        document.getElementById(elementId).value = null;
        setThumbnail(null);
        if (imageKey != "")
            imageDelete(imageKey);
        setImageKey("");
    }

    const getThumbnail = () => {
        return thumbnail;
    }

    const getImageFile = () => {
        return document.getElementById(elementId)?.files?.length > 0 ? document.getElementById(elementId).files[0] : null;
    }

    const setFileContent = (file) => {
        if (file) {
            let container = new DataTransfer();
            container.items.add(file);
            document.getElementById(elementId).files = container.files;
        }
        else {
            document.getElementById(elementId).files = null;
        }
    }


    useImperativeHandle(ref, () => ({
        getThumbnail: getThumbnail,
        setThumbnail: setThumbnail,
        getImageFile: getImageFile,
        setFileContent: setFileContent
    }));

    return (<>
        {thumbnail ? (
            <div className="dropzone d-flex justify-content-center"
                ref={(el) => {
                    if (el) {
                        el.style.setProperty('cursor', 'default', 'important')
                    }
                }} key={0}>
                <div className="d-flex flex-wrap">
                    <div className="dz-preview dz-complete">
                        <div className="dz-details">
                            <div className="dz-thumbnail">
                                <img src={thumbnail} />
                            </div>
                            <a className="dz-remove" href="#" onClick={(e) => handleRemoveFile(e, imageKey)}>
                                Remove file
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div className="dropzone d-flex justify-content-center"
                onClick={browseThumbnail} key={1}>
                <div className="dz-message">
                    Click here to upload
                </div>

            </div>
        )}
        <input className="d-none"
            name="file"
            type="file"
            id={elementId}
            accept="image/*"
            onChange={handleThumbailChange}
        />
        {/* {errors.thumbnail && (
            <div style={{ color: "#ea5455", fontSize: "0.8125rem" }}>
                {errors.thumbnail}
            </div>
        )} */}

        {imageFile && showCropperModal && (
            <ImageCropping
                imageFile={imageFile}
                onClose={handleModalClose}
                onCrop={handleCropSave}
                imageType={imageType}
            />)}
    </>)
});

export default ImageBrowse;